<div>
  <div class="static_steps">
    <div class="side_part" cdkDropList #selectedProductsList="cdkDropList" [cdkDropListConnectedTo]="[productsList]"
      [cdkDropListDisabled]="!canSubmit"
      [cdkDropListData]="selectedData" (cdkDropListDropped)="drop($event)">
      <div class="step">
        <div class="step_title inline_title">
          <div>
            <span>{{"companies_groups.included_locations"|translate}} ({{selectedData.length}})</span>
            <span class="descr_title">{{"companies_groups.drag_drop_location"|translate}} <br> {{"companies_groups.to_remove"|translate}}</span>
          </div>
        </div>
        <div class="inside_content listing_table_container">
          <table class="listing_table">
            <thead class="header_stiky">
              <tr class="head_table">
                <th>{{"companies_groups.location_or"|translate}} <br>{{"companies.customer_groups"|translate}}</th>
                <th>{{"common.wholesale_discount"|translate}}</th>
                <th>{{"Catalogs.additional"|translate}} <br>{{"companies_groups.location_discount"|translate}}</th>
                <th>{{"common.remove"|translate}}</th>
              </tr>
            </thead>
            <tbody class="scrollable-body">
              <ng-container *ngFor="let item of selectedData; let i = index; trackBy: trackByFn">
                <tr class="body_table hover_tr" cdkDrag [cdkDragDisabled]="!canSubmit">
                  <td class="td_block">
                    <img class="icon_img" *ngIf="item.locations && item.locations.length > 0" src="assets/icones/companies_groups.svg" alt="">
                    <span class="bold_span">{{ item.company_name ? item.company_name + ' - ' + item.label : item.label }}</span>
                    <span *ngIf="item.locations && item.locations.length > 0">({{item.locations.length}})</span>
                    <br>
                    <div class="btn_togle" (click)="toggleSelectedGroupe(i)"
                      *ngIf="item.locations && item.locations.length > 0">
                      <img [class]="expandedSeletedIndex === i ? 'arrow_down arrow_up' : 'arrow_down'"
                        src="assets/icones/arrow_down.svg" alt="">
                      <span class="open_variants">{{expandedSeletedIndex === i ? ('inventory.HIDE' | translate) : ('inventory.SHOW' | translate) }}
                      </span>
                    </div>
                    <span class="light_span">{{item.description}}</span>
                  </td>
                  <td>{{currentCustomDiscount ? currentCustomDiscount : 'NA'}}</td>
                  <td class="td_actions">
                    <span class="bold_span">{{item.add_discount}}</span>
                  </td>
                  <td>
                    <button *appHasPermission="submitPermission()" (click)="removeLocation(item, i)">
                      <img src="assets/icones/red-delete-icon.svg" alt="">
                    </button>
                  </td>
                </tr>
                <tr *ngIf="expandedSeletedIndex === i">
                  <td colspan="4" class="td_variants">
                    <div class="variants_scroll">
                      <table class="variant_table">
                        <tr *ngFor="let location of item.locations" class="body_table">
                          <td class="td_block">
                            <span class="bold_span">{{ location.company_name + ' - ' + location.name }}</span><br>
                            <span class="light_span">
                              {{location.apartment}}
                            </span>
                             <span>ID: {{location.id_company || 'N/A'}}</span>
                          </td>
                          <td>{{currentCustomDiscount ? currentCustomDiscount : 'NA'}}</td>
                          <td class="td_actions">
                            <span class="bold_span">{{location.custom_discount}}</span>
                          </td>
                          <td>
                          </td>
                        </tr>
                      </table>
                    </div>

                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="side_part" cdkDropList #productsList="cdkDropList" [cdkDropListConnectedTo]="[selectedProductsList]"
      [cdkDropListDisabled]="!canSubmit"
      [cdkDropListData]="data" (cdkDropListDropped)="drop($event)">
      <div class="step">
        <div class="step_title inline_title">
          <div>
            <span>{{"companies_groups.all_locations"|translate}}({{allLocations.length - selectedData.length}})</span>
            <span class="descr_title">{{"companies_groups.drag_drop_location"|translate}} <br> {{"companies_groups.to_remove"|translate}}</span>
          </div>
          <div class="field">
            <input class="input search_location" type="text" [placeholder]="'companies.search_location_company_group'|translate" [formControl]="search" />
            <img src="assets/icones/search.svg" class="indicate_input" alt="">
          </div>
        </div>
        <div class="inside_content listing_table_container">
          <table class="listing_table">
            <thead class="header_stiky">
              <tr class="head_table">
                <th>{{"companies_groups.location_or"|translate}} <br>{{"companies.customer_groups"|translate}}</th>
                <th>{{"common.wholesale_discount"|translate}}</th>
                <th>{{"Catalogs.additional"|translate}} <br>{{"companies_groups.location_discount"|translate}}</th>
                <th>{{"common.add"|translate}}</th>
              </tr>
            </thead>
            <tbody class="scrollable-body">
              <ng-container *ngFor="let item of data; let i = index; trackBy: trackByFn">
                <tr class="body_table hover_tr" cdkDrag [cdkDragDisabled]="!canSubmit">
                  <td class="td_block">
                    <img class="icon_img" *ngIf="item.type === 'group'" src="assets/icones/companies_groups.svg" alt="">
                    <img class="icon_img" *ngIf="item.type === 'company'" src="assets/icones/companies.svg" alt="">
                    <span class="bold_span">{{ item.company_name ? item.company_name + ' - ' + item.label : item.label }}</span>
                    <span *ngIf="item.locations && item.locations.length > 0">({{item.locations.length}})</span>
                    <br>
                    <div class="btn_togle" (click)="toggleGroupe(i)"
                      *ngIf="item.locations && item.locations.length > 0">
                      <img [class]="expandedIndex === i ? 'arrow_down arrow_up' : 'arrow_down'"
                        src="assets/icones/arrow_down.svg" alt="">
                      <span class="open_variants">{{expandedIndex === i ? ('inventory.HIDE' | translate) : ('inventory.SHOW' | translate) }}
                      </span>
                    </div>
                    <span class="light_span">{{item.description}}</span>
                  </td>
                  <td>{{currentCustomDiscount ? currentCustomDiscount : 'NA'}}</td>
                  <td class="td_actions">
                    <span class="bold_span">{{item.add_discount}}</span>
                  </td>
                  <td>
                    <button *appHasPermission="submitPermission()" (click)="addItem(item, i)">
                      <img src="assets/icones/black-add-icon.svg" alt="">
                    </button>
                  </td>
                </tr>
                <tr *ngIf="expandedIndex === i && item.locations && item.locations.length > 0">
                  <td colspan="4" class="td_variants">
                    <div class="variants_scroll">
                      <table class="variant_table">
                        <tr *ngFor="let location of item.locations" class="body_table">
                          <td class="td_block">
                            <span class="bold_span">{{ location.company_name + ' - ' + location.name }}</span><br>
                            <span class="light_span">{{location.apartment}}</span><br/>
                            <span>ID: {{location.company_id || 'N/A'}}</span>
                          </td>
                          <td>{{currentCustomDiscount ? currentCustomDiscount : 'NA'}}</td>
                          <td class="td_actions">
                            <span class="bold_span">{{location.custom_discount}}</span>
                          </td>
                          <td>
                            <button *appHasPermission="submitPermission()" (click)="addLocation(location, i)">
                              <img src="assets/icones/black-add-icon.svg" alt="">
                            </button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">
      <span>{{submitType === 'stepper' ? ('common.BACK' | translate) : ('common.CANCEL' | translate)}}</span>
      <img src="../../../../../assets/icones/arrow_back.svg" alt="">
    </button>
    <button class="save_btn_pop_up blue_btn" *appHasPermission="submitPermission()" (click)="save()">
      <span>{{submitType === 'stepper' ? ('common.NEXT' | translate) : ('Catalogs.SAVE_CATALOG' | translate)}}</span>
      <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
    </button>
  </div>
</div>
